// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"8b74846c","261":"b5a7701d","359":"0aae3f8f","468":"0ea16666","616":"9d9a551f","741":"5dc7b917","748":"36901c94"}[chunkId] + ".chunk.css";
};